export default __webpack_public_path__ + "static/media/Value Prop.194b1a77.jpg";